/**
 * @returns {React.JSX.Element}
 */
export function TimeIcon() {
  return (
    <svg width="11" height="10" viewBox="0 0 11 10" fill="none">
      <path
        d="M5.31451 0.200195C2.65651 0.200195 0.520508 2.3542 0.520508 4.9942C0.520508 7.6342 2.65651 9.7882 5.31451
          9.7882C7.97251 9.7882 10.1085 7.6522 10.1085 4.9942C10.1085 2.3362 7.96051 0.200195 5.31451 0.200195ZM7.48651
          6.4582C7.33651 6.6622 7.05451 6.7222 6.85051 6.5722L5.05051 5.3722C4.93651 5.3002 4.86451 5.1502 4.86451
          5.0002V2.4502C4.86451 2.2042 5.05051 2.0002 5.31451 2.0002C5.56051 2.0002 5.76451 2.2042 5.76451
          2.4502V4.7722L7.35451 5.8222C7.55851 5.9722 7.61851 6.2542 7.48651 6.4582Z"
      />
    </svg>
  );
}
